import { useState } from 'react';
import Stomp from 'stompjs';

export const useConnectWebSocket = (webSocketData: any) => {
  const [isConnected, setIsConnected] = useState(true);

  if (webSocketData === undefined || webSocketData === null) {
    return {
      subscribe: () => {},
      unsubscribe: () => {},
      isConnected: false,
    };
  }
  let stompClient: Stomp.Client;
  let subscription: Stomp.Subscription;

  const ws = new WebSocket(webSocketData.brokerUrl);

  const headers = {
    login: webSocketData.login,
    passcode: webSocketData.password,
    durable: 'true',
    'auto-delete': 'false',
  };

  stompClient = Stomp.over(ws);
  let retryCount = 0;
  const maxRetries = 5; // Maximum number of retry attempts

  const subscribe = (callback: (arg0: Stomp.Message) => void) => {
    stompClient.connect(
      headers,
      function () {
        // console.log('Connected');
        subscription = stompClient.subscribe(
          webSocketData.notificationExchange,
          function (message) {
            callback(message);
            setIsConnected(true);
          },
        );
      },

      function (error) {
        // This function will be called if the WebSocket connection is lost
        // console.log('STOMP error:', error);
        setIsConnected(false);

        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(() => {
            // Attempt to reconnect here
            stompClient.connect(
              {},
              function () {
                // console.log('Reconnected');
                setIsConnected(true);
                retryCount = 0; // Reset retry count after successful connection
                subscription = stompClient.subscribe(
                  webSocketData.notificationExchange,
                  function (message) {
                    // console.log('message:', message);
                    callback(message);
                    setIsConnected(true);
                  },
                );
              },
              function (error) {
                setIsConnected(false);
              },
            );
          }, 3000); // Wait 3 seconds before retrying
        } else {
          // Show a message to the user
        }
      },
    );
  };

  const unsubscribe = () => {
    if (subscription) {
      subscription.unsubscribe();
    }
  };

  return { subscribe, unsubscribe, isConnected };
};
